// extracted by mini-css-extract-plugin
export default {"orderList":"orderList_style_orderList__bvGsi","noOrders":"orderList_style_noOrders__d5rzZ"};